/**
 * SavePendingButton Component
 *
 * Save button for pending changes in inline edit mode.
 */

import React from "react";
import { Button } from "@/components/ui/button";
import { Save } from "lucide-react";

interface SavePendingButtonProps {
  onClick: () => void;
  isLoading?: boolean;
}

const SavePendingButtonBase: React.FC<SavePendingButtonProps> = ({
  onClick,
  isLoading = false,
}) => {
  return (
    <Button
      variant="default"
      size="default"
      disabled={isLoading}
      className="gap-2 min-h-[44px] touch-manipulation active:scale-[0.98] bg-emerald-600 hover:bg-emerald-700"
      onClick={onClick}
    >
      <Save className="h-4 w-4 shrink-0" aria-hidden />
      <span>Save</span>
    </Button>
  );
};

export const SavePendingButton = React.memo(SavePendingButtonBase);
